import { Injectable } from '@angular/core';
import { AbstractService } from '@increff/commons';
import { Rest } from '../rest.service';
import { Observable } from 'rxjs';
import { AUDIT_PAYLOAD, AUDIT_RESPONSE } from '../../interfaces/audit.interface';

@Injectable({
    providedIn: 'root',
})
export class AuditService {
    constructor(private abstractService: AbstractService, private urls: Rest) {}

    getAuditLog(
        body: AUDIT_PAYLOAD,
        type: 'admin' | 'domain' = 'admin'
    ): Observable<AUDIT_RESPONSE[]> {
        return this.abstractService.exec(
            type === 'admin' ? this.urls.adminAuditLogUrl : this.urls.domainAuditLogUrl,
            'POST',
            body
        );
    }

    getAuditActions(): Observable<string[]> {
        return this.abstractService.exec(this.urls.auditActionsUrl, 'GET');
    }

    getAuditReport(body: AUDIT_PAYLOAD, type: 'admin' | 'domain' = 'admin'): Observable<Blob> {
        return this.abstractService.exec(
            type === 'admin' ? this.urls.adminAuditReportUrl : this.urls.domainAuditReportUrl,
            'PUT',
            body,
            {responseType: 'application/octet-stream'}
        );
    }
}
